module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.333 22V10l8 6-8 6zm0-6l-8 6V10l8 6z\"></path></svg>"